// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const streetLamp = defineModel({
  id: "street-lamp",
  batchId: "future",
  name: "Street lamp",
  tags: ["scenery","street","lamp","low-poly","age-of-mcp","future"],
  summary: "A street lamp — lights a road or path after dark.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.18,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.08, 0.1, 0.06, 8), color: "#474d53", position: [0, 0.03, 0] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.07, 0.06, 8), color: "#33383d", position: [0, 0.09, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.035, 1.05, 8), color: "#33383d", position: [0, 0.64, 0] },
      { geometry: new THREE.TorusGeometry(0.04, 0.012, 4, 8), color: "#474d53", position: [0, 1.05, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.16), color: "#33383d", position: [0, 1.2, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.16, 0.12), color: "#ffe6b0", position: [0, 1.06, 0] },
      { geometry: new THREE.SphereGeometry(0.05, 7, 6), color: "#fff0c2", position: [0, 1.06, 0] },
      { geometry: new THREE.BoxGeometry(0.13, 0.02, 0.13), color: "#33383d", position: [0, 1.14, 0] },
      { geometry: new THREE.BoxGeometry(0.13, 0.02, 0.13), color: "#33383d", position: [0, 0.98, 0] },
      { geometry: new THREE.ConeGeometry(0.1, 0.1, 4), color: "#262a2e", position: [0, 1.2, 0], rotation: [0, 0.785398, 0] },
      { geometry: new THREE.SphereGeometry(0.02, 5, 4), color: "#262a2e", position: [0, 1.27, 0] },
    ],
  animations: [],
});
